import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

export function EducationModalHeading(): JSX.Element {
	return (
		<div className="items-baseline border-b border-stroke-weaker pr-8">
			<Text variant="heading" as="h1" size="small">
				<Translate value="corgi.psf.share.modals.heading.title" replacements={{ shareChannel: 'Instagram' }} />
			</Text>
		</div>
	);
}
